import { useLayoutEffect, useState } from 'react';

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window?.innerWidth || 0,
    height: window?.innerHeight || 0,
  });

  useLayoutEffect(() => {
    const handler = () => {
      setWindowSize({
        width: window?.innerWidth || 0,
        height: window?.innerHeight || 0,
      });
    };
    handler();
    window.addEventListener('resize', handler);

    return () => {
      window.removeEventListener('resize', handler);
    };
  }, []);

  return windowSize;
}

export default useWindowSize;
